/** Resident Actions folder card: six resident-focused finance cards live inside it instead of loose on the grid. */
export const RESIDENT_ACTIONS_ID = "cap_fin_res_actions";
export const RESIDENT_ACTION_CAPS = ["cap_fin_11", "cap_fin_02", "cap_fin_review", "cap_fin_01", "cap_fin_03", "cap_fin_04"];
const CHILD = new Set(RESIDENT_ACTION_CAPS);
const ANCHOR = "cap_fin_05";

/** The folder takes the place of the first of its six cards in a saved order; the other five drop out. */
export const migrateOrder = (order) => {
  if (!Array.isArray(order) || order.includes(RESIDENT_ACTIONS_ID)) return order;
  if (!order.some((id) => CHILD.has(id))) {
    // Saved before the folder existed and without the six: it belongs right before Landlord Invoicing, where the six used to sit.
    const i = order.indexOf(ANCHOR);
    return i < 0 ? order : [...order.slice(0, i), RESIDENT_ACTIONS_ID, ...order.slice(i)];
  }
  let placed = order.includes(RESIDENT_ACTIONS_ID);
  return order.flatMap((id) => {
    if (!CHILD.has(id)) return [id];
    if (placed) return [];
    placed = true;
    return [RESIDENT_ACTIONS_ID];
  });
};

export const isResidentActionChild = (id) => CHILD.has(id);

const num = (m, re) => Number(((m?.metric || "").match(re) || [])[1] || 0);

/** Folder summary built only from the child cards this viewer may open (labels kept separate, ledger rows never included). */
export const folderSummary = (metrics, allowedIds) => {
  const ok = new Set(allowedIds);
  const pick = (id, re) => (ok.has(id) ? num(metrics?.[id], re) : 0);
  const parts = [[pick("cap_fin_02", /^(\d+)/), "to verify"], [pick("cap_fin_03", /^(\d+)/) + pick("cap_fin_11", /^(\d+)/), "pending"],
    [pick("cap_fin_04", /^(\d+)/), "open"], [pick("cap_fin_review", /(\d+) MISSING/), "missing"]].filter(([n]) => n > 0);
  return parts.map(([n, l]) => `${n} ${l}`).join(" · ") || "All clear";
};

/** Main-grid view of cards: hide the six children; show the folder only if at least one child is allowed (never new access). */
export const groupResidentActions = (caps, allowed, notDeleted) => {
  const anyChild = caps.some((c) => CHILD.has(c.id) && allowed(c));
  return caps.filter((c) => (c.id === RESIDENT_ACTIONS_ID ? anyChild && notDeleted(c) : !CHILD.has(c.id) && allowed(c)));
};
